import i18n from '@/i18n';

//判斷是否是手機端(APP、移動端)
export const is_mobile = function () {
  // 判斷是否手機端
  var is_mobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
      navigator.userAgent
    );
  return is_mobile;
};

export const getSpan = function () {
  if (is_mobile()) {
    return 24;
  }
  return 12;
};

export const ApiLanguage = function () {
  const language =
    ['ZH_HANT', 'PT', 'EN'][['zh-TW', 'pt', 'en'].indexOf(i18n.locale)] ||
    'ZH_HANT';
  return language;
};

export const isWeChatBrowser = function () {
  return /MicroMessenger/i.test(navigator.userAgent);
};

export const isZHHANT = function () {
  console.log(i18n.locale.toUpperCase());
  if (i18n.locale.toUpperCase() === 'ZH-HANT') {
    return true;
  }
  return false;
};

export const downloadFile = function (res) {
  // 下載文件
  let blobData = new Blob([res.data]);
  let fileName = res.headers['content-disposition'].split(';')[1].split('=')[1];
  fileName = fileName ? decodeURI(fileName) : '.pdf';
  let elink = document.createElement('a');
  elink.download = fileName;
  elink.style.display = 'none';
  elink.href = URL.createObjectURL(blobData);
  document.body.appendChild(elink);
  elink.click();
  URL.revokeObjectURL(elink.href);
  document.body.removeChild(elink);
};
